import React from 'react';
import { BookOpenIcon, CalendarIcon, CheckCircleIcon } from 'lucide-react';
export const CourseDetails = () => {
  return <section className="mb-10" data-id="element-52">
      <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center" data-id="element-53">
        <BookOpenIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-54" />
        De Gids Voor De Hondentaal: Hoe Het Werkt
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-55">
        In plaats van je hond te dwingen om jouw regels te volgen, leert mijn
        'Liefdevol Communiceren' cursus je de grammatica en woordenschat van de
        hondentaal.
      </p>
      <div className="w-full mb-6" data-id="element-56">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/adfEt27Jye6FQiTqbD9WSK/Scherm%C2%ADafbeelding_2025-08-15_om_15.38.32.png" alt="Hond en eigenaar communiceren met handgebaren" className="w-full h-auto rounded-lg shadow-md" data-id="element-57" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-58">
          Handgebaren zijn 99% effectief en vormen een belangrijk onderdeel van
          de hondentaal
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-59">
        Je leert niet alleen signalen van je hond te lezen, maar ook hoe je
        terugpraat op een manier die je hond enorm waardeert. Het
        attentiesignaal leert je om de hyperfocus van je hond te onderbreken, en
        handgebaren leren je om duidelijke grenzen te stellen zonder te
        straffen.
      </p>
      <p className="mb-8 leading-relaxed" data-id="element-60">
        Het mooie is dat deze taal helemaal niet moeilijk is. Honden
        communiceren heel direct en eerlijk. Het is alleen anders dan wat wij
        gewend zijn.
      </p>
      <h3 className="text-lg font-bold text-blue-800 mb-4 flex items-center" data-id="element-61">
        <CalendarIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-62" />
        Je Transformatie Week Voor Week
      </h3>
      <div className="space-y-6 mb-8" data-id="element-63">
        <div className="flex" data-id="element-64">
          <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-65">
            1
          </div>
          <div data-id="element-66">
            <h4 className="font-bold mb-1" data-id="element-67">
              Week 1: Emoties beter herkennen bij je hond
            </h4>
            <p className="text-gray-700" data-id="element-68">
              In de eerste week begin je de subtiele verschillen te zien. Wat je
              altijd dacht dat angst was, herken je nu als beleefdheid.
              Stresssignalen vang je op voordat ze escaleren. Voor het eerst in
              jaren krijg je het gevoel: "Ik begrijp mijn hond echt."
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-69">
          <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-70">
            2
          </div>
          <div data-id="element-71">
            <h4 className="font-bold mb-1" data-id="element-72">
              Week 2: Hij lijkt jou beter te begrijpen
            </h4>
            <p className="text-gray-700" data-id="element-73">
              Je handgebaren worden duidelijker en consistenter. Je merkt dat je
              hond sneller reageert op je signalen. Die frustrerende momenten
              van miscommunicatie worden minder. Je voelt de eerste echte
              momenten van verbinding.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-74">
          <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-75">
            3
          </div>
          <div data-id="element-76">
            <h4 className="font-bold mb-1" data-id="element-77">
              Week 3: Stress bij de hond wordt minder, probleemgedrag neemt af
            </h4>
            <p className="text-gray-700" data-id="element-78">
              De wandelingen worden rustiger. Het constante geblaf vermindert.
              Je hond springt minder op bij bezoek. Je merkt een merkbare
              ontspanning bij jullie beiden - jullie beginnen elkaar echt te
              vertrouwen.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-79">
          <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-80">
            4
          </div>
          <div data-id="element-81">
            <h4 className="font-bold mb-1" data-id="element-82">
              Week 4: De relatie is verbeterd en jullie hebben veel meer plezier
              samen
            </h4>
            <p className="text-gray-700" data-id="element-83">
              Nu kun je ontspannen wandelen zonder constant aan de riem te
              hoeven trekken. Je kunt weer spontaan de deur uit zonder lange
              voorbereiding. Voor het eerst in tijden voel je je trots als
              hondeneigenaar.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-84">
          <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-85">
            ✓
          </div>
          <div data-id="element-86">
            <h4 className="font-bold mb-1" data-id="element-87">
              Langetermijn: De Diepe Verbinding
            </h4>
            <p className="text-gray-700" data-id="element-88">
              Na een paar maanden ervaar je die 'once in a lifetime' connectie
              steeds vaker. Mensen complimenteren je met hoe goed je hond
              luistert. Je hebt een harmonieus huishouden waar je hond
              natuurlijk past binnen het gezinsleven. Die constante stress is
              vervangen door echte vreugde.
            </p>
          </div>
        </div>
      </div>
      <div className="w-full mb-6" data-id="element-89">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad in de namiddagzon" className="w-full h-auto rounded-lg shadow-md" data-id="element-90" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-91">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-92">
        <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-93">
          De Liefdevol Communiceren Cursus
        </h3>
        <p className="mb-4" data-id="element-94">
          Deze transformatie wordt mogelijk gemaakt door mijn online cursus
          'Liefdevol Communiceren', bestaande uit 7 praktische modules:
        </p>
        <div className="space-y-4" data-id="element-95">
          <div className="flex" data-id="element-96">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-97">
              1
            </div>
            <div data-id="element-98">
              <h4 className="font-bold" data-id="element-99">Tools voor het dagelijks leven</h4>
              <p className="text-sm text-gray-700" data-id="element-100">
                Doorbreek miscommunicatie met kalmerende signalen en voorkom
                stress door subtiele lichaamstaal te leren.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-101">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-102">
              2
            </div>
            <div data-id="element-103">
              <h4 className="font-bold" data-id="element-104">
                Sociale vaardigheden - Omgangsregels
              </h4>
              <p className="text-sm text-gray-700" data-id="element-105">
                Begrijp hondenetiquette, leer subtiele "beleefdheidsgebaren" van
                je hond en respecteer zijn persoonlijke ruimte.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-106">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-107">
              3
            </div>
            <div data-id="element-108">
              <h4 className="font-bold" data-id="element-109">Tafelmanieren</h4>
              <p className="text-sm text-gray-700" data-id="element-110">
                Vaste routines voor een rustige hond, impulscontrole die
                probleemgedrag vermindert.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-111">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-112">
              4
            </div>
            <div data-id="element-113">
              <h4 className="font-bold" data-id="element-114">Je eigen reacties</h4>
              <p className="text-sm text-gray-700" data-id="element-115">
                Leer hoe jouw stress zijn stress wordt en hoe rustig praten tot
                sneller luisteren leidt.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-116">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-117">
              5
            </div>
            <div data-id="element-118">
              <h4 className="font-bold" data-id="element-119">Het Handsignaal</h4>
              <p className="text-sm text-gray-700" data-id="element-120">
                Ontdek waarom handgebaren 99% effectief zijn versus 82% bij
                stemcommando's, en leer grenzen stellen zonder geschreeuw.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-121">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-122">
              6
            </div>
            <div data-id="element-123">
              <h4 className="font-bold" data-id="element-124">Het Attentiesignaal</h4>
              <p className="text-sm text-gray-700" data-id="element-125">
                Pak altijd eerst de aandacht van je hond, voorkom uitvallen met
                de "check-in" techniek.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-126">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-127">
              7
            </div>
            <div data-id="element-128">
              <h4 className="font-bold" data-id="element-129">Stressreductie</h4>
              <p className="text-sm text-gray-700" data-id="element-130">
                Leer hoe liefdevol gedrag leidt tot laag cortisol en hoe je
                samen ontspant voor hormonen in balans.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8" data-id="element-131">
        <h3 className="text-lg font-bold text-green-800 mb-4" data-id="element-132">Bonussen:</h3>
        <ul className="space-y-3 mb-4" data-id="element-133">
          <li className="flex items-start" data-id="element-134">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-135" />
            <span data-id="element-136">Masterclass "Honden Geschiedenis" (€7 waarde)</span>
          </li>
          <li className="flex items-start" data-id="element-137">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-138" />
            <span data-id="element-139">8 online, printbare stappenplannen (€44 waarde)</span>
          </li>
          <li className="flex items-start" data-id="element-140">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-141" />
            <span data-id="element-142">Levenslange, onbeperkte toegang tot de complete cursus</span>
          </li>
        </ul>
        <div className="bg-white p-4 rounded-lg border border-green-200" data-id="element-143">
          <p className="font-bold text-green-800 mb-2" data-id="element-144">En heel bijzonder:</p>
          <p className="text-green-800" data-id="element-145">
            30 dagen gratis toegang tot onze exclusieve community waar je direct
            met mij als gedragsdeskundige je specifieke situatie kan bespreken.
            Het is ook ontzettend leuk om met andere hondenbaasjes te sparren
            over wat je hond in bepaalde situaties denkt en voelt. Je bent niet
            alleen in deze reis!
          </p>
        </div>
      </div>
    </section>;
};